import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getCarModelDetails = (id) => {
  const url = API_URLS.carModelDetail(id);
  return axiosClient.get(url);
};

export const getCarModelTable = () => {
  const url = API_URLS.truckTable;
  return axiosClient.get(url);
};

export const getCarModelCharacteristics = () => {
  const url = API_URLS.tableCharacteristics;
  return axiosClient.get(url);
};
